module.exports = __webpack_public_path__ + "img/ChampionHub.3332676f.svg";